import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=1b6890e2&"
import script from "./Traceability.vue?vue&type=script&lang=js&"
export * from "./Traceability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6890e2')) {
      api.createRecord('1b6890e2', component.options)
    } else {
      api.reload('1b6890e2', component.options)
    }
    module.hot.accept("./Traceability.vue?vue&type=template&id=1b6890e2&", function () {
      api.rerender('1b6890e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/Traceability.vue"
export default component.exports